'use strict';
var base = require('base/product/base');

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

// TO DO  put this function in a util to be used by other scripts
function getQueryParams(qs) {
    qs = qs.split('+').join(' ');

    var params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
}


module.exports = {
    availability: base.availability,
    addToCart: base.addToCart,
    addToCartmarketplace: function () {
        $(document).on('click', 'button.add-to-cart-marketplace', function () {
            var addToCartUrl;
            var pid;

            $('body').trigger('product:beforeAddToCart', this);

            pid = $(this).data('pid');

            addToCartUrl = $('.add-to-cart-url').val();

            var form = {
                pid: pid,
                pidsObj: null,
                childProducts: [],
                quantity: $('.quantity-select').val()
            };

            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        $('.minicart').trigger('count:update', data);
                        $('body').trigger('product:afterAddToCart', data);
                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').off('product:afterAttributeSelect').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
            response.container.find('.sellers').empty().html(response.data.product.marketplaceHtml);
            response.container.find('.soldBy').empty().html(response.data.product.soldByHtml);
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            $('button.add-to-cart-global').attr('disabled', !enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),

    viewShippingCosts: function () {
        $('body').on('submit', '.sellers-shipping-cost-form', function (ev) {
            ev.preventDefault();

            var form = $(this);
            var url = form.attr('action');
            var sellers = $('.sellers');
            sellers.spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    $('body').spinner().stop();
                    if (!data) {
                        $('body').spinner().stop();
                    } else {
                        $('.sellers__list').empty().append(data.marketplaceHtml);
                    }

                    sellers.spinner().stop();
                },
                error: function (err) {
                    sellers.spinner().stop();
                }
            });
        });

        var zipcodeInput = $('input[name="dwfrm_address_postalCode"]');
        if (zipcodeInput.length && zipcodeInput[0].validity.valid) {
            $('body .sellers-shipping-cost-form').trigger('submit');
        }
    },

    changeSortOrder: function () {
        $('body').on('change', 'select[name="sellersSortBy"]', function (ev) {
            var currentTarget = ev.currentTarget;
            var selectValue = currentTarget.value;
            var attributes = $(this).attr('data-attributes');
            var qtyBuybox = Number($('#qtyBuyBox').val());

            var sortBy = {
                sortByValue: selectValue,
                attributes: attributes,
                qtyBuybox: qtyBuybox
            };

            var url = $(this).attr('data-action');

            $('body').spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                data: sortBy,
                success: function (data) {
                    $('body').spinner().stop();
                    if (!data) {
                        $('body').spinner().stop();
                    } else {
                        $('.sellers__list').empty().append(data.marketplaceHtml);
                    }
                },
                error: function () {
                    $('body').spinner().stop();
                }
            });
        });
    },

    scrollToBuyBox: function () {
        var buybox = $('.buybox-options');
        if (buybox.length > 0) {
            $('html').stop(true, true).delay(300).animate({
                scrollTop: $(buybox).offset().top
            }, 1000);
        }
    }
};
